import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AssinarDocumentoService } from '../../../../services/assinar-documento.service';
import { CdkStepper } from '@angular/cdk/stepper';
import { Location } from '@angular/common';
import { StatusDocumentoAssinatura } from '../../../../models/status-documento';
import { ToastService } from 'src/app/shared/toasts/toast-service';

@Component({
  selector: 'app-editar-contrato',
  templateUrl: './editar-contrato.component.html',
  styleUrl: './editar-contrato.component.scss'
})
export class EditarContratoComponent implements OnInit {
  @ViewChild('cdkSteppers', { static: false }) cdkSteppers!: CdkStepper;

  isLoading: boolean = false;

  breadCrumbItems!: Array<{}>;

  statusDocumento!: StatusDocumentoAssinatura;
  documentoEmAssiantura = true;
  arquivoEnviado: boolean = false;

  etapaDocumento: boolean = false;
  etapaAssinatura: boolean = false;
  etapaEmail: boolean = false;

  desabilitarEtapaDocumento: boolean = false;
  desabilitarEtapaAssinatura: boolean = false;
  desabilitarEtapaEmail: boolean = false;

  abaEtapa:number = 1;

  contratoId = "";

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private location: Location,
    private toastService: ToastService,
    private assinarDocumentoService: AssinarDocumentoService) { }

  ngOnInit(): void {
    this.contratoId = this.route.snapshot.paramMap.get('id')!;

    this.consultarDocumentoAssinatura(this.contratoId);

    this.statusDocumento = {
      descricaoStatus: "",
      statusDocumentoAssinatura: 0,
      documentoUuId: ""
    }

    this.breadCrumbItems = [
      { label: "Projetos" },
      { label: "Assinar Contrato", active: true }
    ];

  }

  // metodo responsavel por enviar o arquivo para assinatura
  enviarArquivoAssinatura() {
    this.isLoading = true;

    if (this.statusDocumento.statusDocumentoAssinatura == 3) {
      this.assinarDocumentoService.enviarParaAssinar(this.statusDocumento.documentoUuId!).subscribe({
        next: (res) => {

          this.toastService.show("Realizado solicitação de envio de e-mail com sucesso.", {
            classname: "bg-success text-light",
          });

          setTimeout(() => {
            window.location.reload();
          }, 3000);
          this.isLoading = false;
        },
        error: (err) => {
          this.toastService.show("Erro ao solicitar evio de e-mail", {
            classname: "bg-danger text-light",
          });
          this.isLoading = false;
        }
      })
    }
  }


  // Consulta de documento assinado
  consultarDocumentoAssinatura(documentoId: string) {
    this.assinarDocumentoService.consultarDocumentoAssinatura(documentoId).subscribe({
      next: (res) => {

        this.EtapaDocumentoFinalizada(res.statusDocumentoAssinatura);

        this.statusDocumento = res != null ? res : {
          descricaoStatus: "",
          statusDocumentoAssinatura: 0,
          documentoUuId: ""
        };
        if (res) {
          this.arquivoEnviado = true;
        } else {

        }
      }
    });
  }

  voltar() {
    this.location.back();
  }


  // Verifica se etapa documento esta finalizada
  // se TRUE, é finalizado.
  EtapaDocumentoFinalizada(statusDocumentoAssinatura?: number) {
    if (statusDocumentoAssinatura == 0) {
      //DOCUMENTO 
      this.etapaDocumento = false;

      this.desabilitarEtapaAssinatura = true;
      this.desabilitarEtapaEmail = true;
    } else if (statusDocumentoAssinatura == 2) {
      this.abaEtapa = 2;

      //DOCUMENTO 
      this.etapaDocumento = true;

      //Singatario
      this.etapaAssinatura = false;

      this.desabilitarEtapaDocumento = true;
      this.desabilitarEtapaEmail = true;
    } else if (statusDocumentoAssinatura == 3) {
      this.abaEtapa = 3;

      //DOCUMENTO 
      this.etapaDocumento = true;

      //Singatario
      this.etapaAssinatura = true;

      this.desabilitarEtapaDocumento = true;
      this.desabilitarEtapaAssinatura = true;

      this.etapaEmail = false;
    } else if (statusDocumentoAssinatura == 1 
      || statusDocumentoAssinatura == 4 
      || statusDocumentoAssinatura == 5 
      || statusDocumentoAssinatura == 6) 
      {
        this.abaEtapa = 0;

      this.etapaDocumento = true;
      this.etapaAssinatura = true;
      this.etapaEmail = true;

      this.desabilitarEtapaDocumento = true;
      this.desabilitarEtapaAssinatura = true;
      this.desabilitarEtapaEmail = true;
    }
  }
}
